module.exports = __webpack_public_path__ + "img/special-car.86623dc.svg";